import { render, staticRenderFns } from "./CustomerAssets.vue?vue&type=template&id=218a66a6"
import script from "./CustomerAssets.vue?vue&type=script&lang=js"
export * from "./CustomerAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports